import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getDatabase } from 'firebase/database';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

// Конфигурация Firebase
const firebaseConfig = {
  apiKey: "AIzaSyDrGpIpneoRCIrFtEhyiCUDfLM-Pvl02mY",
  authDomain: "spario-2d6d2.firebaseapp.com",
  databaseURL: "https://spario-2d6d2-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "spario-2d6d2",
  storageBucket: "spario-2d6d2.firebasestorage.app",
  messagingSenderId: "770240014851",
  appId: "1:770240014851:web:679af4c08d93ec4eb2fc36",
  measurementId: "G-MGHYGL0HFL"
};

// Инициализация приложения Firebase
const app = initializeApp(firebaseConfig);

// Экспорт сервисов Firebase
export const auth = getAuth(app); // Аутентификация Firebase
export const db = getFirestore(app); // Firestore для работы с базой данных
export const realtimeDb = getDatabase(app); // Реальная база данных (Realtime Database)
export const storage = getStorage(app); // Хранилище для файлов
export const functions = getFunctions(app); // Облачные функции (Cloud Functions)
export const messaging = getMessaging(app); // Обработка сообщений (FCM)

// Регистрация Service Worker и получение токена FCM
export const requestForToken = async () => {
    try {
      // Регистрируем Service Worker для обработки push-уведомлений
      const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');

      // Получаем токен FCM с зарегистрированным Service Worker
      const currentToken = await getToken(messaging, { 
        vapidKey: 'BJroAxoAUPWhibFpcwprGtl9JZbdzFZjjPZkwfg2rgDgCoL5BuJedX97B2OYxQ_PsDI6OjO3QUlR9yWQQIgmlh0', 
        serviceWorkerRegistration: registration 
      });

      if (currentToken) {
        console.log('Current token:', currentToken);
        return currentToken;
      } else {
        console.log('No registration token available. Request permission to generate one.');
        return null;
      }
    } catch (error) {
      console.error('An error occurred while retrieving token: ', error);
      return null;
    }
};

// Функция для прослушивания входящих сообщений FCM
export const onMessageListener = () => {
    return new Promise((resolve) => {
      onMessage(messaging, (payload) => {
        console.log('Message received: ', payload);
        resolve(payload);
      });
    });
};
